import React from 'react';
import Header from './components/Header';
import HeroSlider from './components/HeroSlider';
import Services from './components/Services';
import Solutions from './components/Solutions';
import Training from './components/Training';
import Clients from './components/Clients';
import SocialPlatforms from './components/SocialPlatforms';
import Footer from './components/Footer';
import '../src/styles/globals.css';
import '../src/styles/App.css';
// import Metroblits from './components/Metroblits';

function App() {
  return (
    <div className="App">
      <Header />
      {/* <Metroblits /> */}
      <HeroSlider />
      <Services />
      <Solutions />
      <Training />
      <Clients />
      <SocialPlatforms />
      <Footer />
    </div>
  );
}

export default App;
